import { FeatureFlag } from '@revelio/core';

import { useBrand } from '../../../shared/branding/brand-provider';
import { useUnleashFlag } from '../../../shared/unleash-flags/use-unleash-flag';
import styles from './Logo.module.css';

export const RevelioSidebarLogoNew = () => {
  return (
    <svg
      width="34"
      height="33"
      viewBox="3 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5573 0H20C10.9133 0 3.5 7.41327 3.5 16.5C3.5 25.5867 10.9133 33 20 33C29.0867 33 36.5 25.5867 36.5 16.5V15.9427L20.5573 0Z"
        fill="var(--rl-logo-circle, #25282D)"
      />
      <path
        d="M26.2234 9.47646C26.2234 9.10304 25.9207 8.80032 25.5473 8.80032H23.718C23.3479 8.80032 23.0465 9.09791 23.0419 9.46802L23.0249 10.8311V23.5073C23.0249 23.8807 23.3276 24.1834 23.701 24.1834H25.5473C25.9207 24.1834 26.2234 23.8807 26.2234 23.5073V9.47646Z"
        fill="var(--rl-logo-text, #fff)"
      />
      <path
        d="M16.965 14.6542V13.5703C16.965 13.1969 16.6623 12.8942 16.2889 12.8942H14.4427C14.0693 12.8942 13.7666 13.1969 13.7666 13.5703V23.5227C13.7666 23.8961 14.0693 24.1988 14.4427 24.1988H16.2889C16.6623 24.1988 16.965 23.8961 16.965 23.5227V20.0188C16.965 16.6172 18.2682 15.5342 20.4005 15.5342C20.5906 15.5342 20.7477 15.386 20.759 15.1963L20.8677 13.3704C20.89 12.9959 20.6027 12.6704 20.2278 12.6827C18.6696 12.7339 17.5439 13.3034 16.965 14.6542Z"
        fill="var(--rl-logo-text, #fff)"
      />
      <path
        d="M36.5004 15.9421C36.1015 15.9421 35.7033 15.9421 35.3843 15.8614C27.6528 15.065 21.5148 8.92699 20.7176 1.19472C20.7176 0.796517 20.6384 0.477515 20.6384 0.0793152L36.5004 15.9421Z"
        fill="#A6F075"
      />
    </svg>
  );
};

/** Default Revelio Labs sidebar logo (45x45) */
export const RevelioSidebarLogo = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_358_2)">
        <path
          d="M23.26 0H22.5C10.109 0 0 10.109 0 22.5C0 34.891 10.109 45 22.5 45C34.891 45 45 34.891 45 22.5V21.74L23.26 0Z"
          fill="url(#paint0_linear_358_2)"
        />
        <path
          d="M30.9868 13.922C30.9868 13.4128 30.574 13 30.0648 13H27.5703C27.0656 13 26.6547 13.4058 26.6484 13.9105L26.6252 15.7692V33.0549C26.6252 33.5641 27.038 33.9769 27.5472 33.9769H30.0648C30.574 33.9769 30.9868 33.5641 30.9868 33.0549V13.922Z"
          fill="#EBEBEB"
        />
        <path
          d="M18.3615 20.9845V19.5065C18.3615 18.9973 17.9487 18.5845 17.4395 18.5845H14.922C14.4128 18.5845 14 18.9973 14 19.5065V33.0779C14 33.5871 14.4128 33.9999 14.922 33.9999H17.4395C17.9487 33.9999 18.3615 33.5871 18.3615 33.0779V28.2999C18.3615 23.6614 20.1385 22.1845 23.0462 22.1845C23.3054 22.1845 23.5197 21.9825 23.5351 21.7238L23.6833 19.2339C23.7137 18.7233 23.322 18.2794 22.8107 18.2962C20.6859 18.3659 19.1509 19.1426 18.3615 20.9845Z"
          fill="#EBEBEB"
        />
        <path
          d="M30.9868 12.922C30.9868 12.4128 30.574 12 30.0648 12H27.5703C27.0656 12 26.6547 12.4058 26.6484 12.9105L26.6252 14.7692V32.0549C26.6252 32.5641 27.038 32.9769 27.5472 32.9769H30.0648C30.574 32.9769 30.9868 32.5641 30.9868 32.0549V12.922Z"
          fill="#2D426A"
        />
        <path
          d="M18.3615 19.9845V18.5065C18.3615 17.9973 17.9487 17.5845 17.4395 17.5845H14.922C14.4128 17.5845 14 17.9973 14 18.5065V32.0779C14 32.5871 14.4128 32.9999 14.922 32.9999H17.4395C17.9487 32.9999 18.3615 32.5871 18.3615 32.0779V27.2999C18.3615 22.6614 20.1385 21.1845 23.0462 21.1845C23.3054 21.1845 23.5197 20.9825 23.5351 20.7238L23.6833 18.2339C23.7137 17.7233 23.322 17.2794 22.8107 17.2962C20.6859 17.3659 19.1509 18.1426 18.3615 19.9845Z"
          fill="#2D426A"
        />
        <path
          opacity="0.08"
          d="M23.26 0L45 21.74C31.304 21.74 23.26 13.913 23.26 0Z"
          fill="black"
        />
        <path
          d="M45.0001 21.7399C44.4561 21.7399 43.9131 21.7399 43.4781 21.6299C32.9351 20.5439 24.5651 12.1739 23.4781 1.62989C23.4781 1.08689 23.3701 0.651887 23.3701 0.108887L45.0001 21.7399Z"
          fill="#48EB8F"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_358_2"
          x1="22.5"
          y1="0"
          x2="22.5"
          y2="45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_358_2">
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

/** Brand-aware sidebar logo — renders the logo from the active brand config */
export const Logo = () => {
  const brand = useBrand();
  const isNewTheme = useUnleashFlag(FeatureFlag.DashboardNewLayout);
  const LogoComponent = brand.logos.sidebarLogo;

  if (isNewTheme && LogoComponent === RevelioSidebarLogo) {
    return (
      <>
        <span className={styles.default}>
          <RevelioSidebarLogo />
        </span>
        <span className={styles.badge}>
          <RevelioSidebarLogoNew />
        </span>
      </>
    );
  }

  return <LogoComponent />;
};

export default Logo;
